var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZupeeWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 16,
    viewBox: "0 0 73 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79207 12.1162H13.9487L13.6765 15.816H0.369227L0.0969676 13.1792L7.66806 3.70971H0L0.272259 0.0136719H13.2028L13.4489 2.72509L5.79207 12.1162Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5815 9.02191V0H19.9937V8.85035C19.9937 10.648 20.7396 12.0317 22.8058 12.0317C24.872 12.0317 25.6403 10.6741 25.6403 8.85035V0H29.989V9.02191C29.989 13.5571 27.1284 16 22.8617 16C18.5167 16 15.5815 14.0531 15.5815 9.02191Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8261 0C43.8797 0 45.8788 2.41678 45.8788 5.79208C45.8788 9.16737 43.2681 11.6364 38.6284 11.6364C38.0761 11.6399 37.5241 11.6063 36.9762 11.5357V15.8023H32.5977V0H38.8261ZM41.366 5.77716C41.366 4.65828 40.5044 3.68112 38.5799 3.68112H36.9762V7.78368C37.5004 7.85354 38.0288 7.88718 38.5576 7.88438C40.5529 7.91422 41.366 6.89604 41.366 5.77716Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2174 12.1175L58.9451 15.8172H51.5493C49.0356 15.8172 47.4468 15.0042 47.4468 11.6252V0H58.8631L58.5908 3.67366H51.7955V6.01585H57.6883L57.416 9.6373H51.7955V11.2149C51.7955 11.7594 52.0193 12.1026 52.6085 12.1026L59.2174 12.1175Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8214 12.1175L72.5491 15.8172H65.1533C62.6396 15.8172 61.0508 15.0042 61.0508 11.6252V0H72.4634L72.1911 3.67366H65.4181V6.01585H71.3072L71.0125 9.6373H65.4181V11.2149C65.4181 11.7594 65.6382 12.1026 66.2312 12.1026L72.8214 12.1175Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZupeeWhiteLogo);
export default __webpack_public_path__ + "static/media/zupee-white-logo.4ed60d7478bfd0f66073343ae5c4b2c3.svg";
export { ForwardRef as ReactComponent };